// src/components/study/CardMediaRenderer.tsx
// ✅ ATUALIZADO: Ignora imagens antigas (localhost), renderiza apenas Cloudinary

import React from 'react';
import './CardMediaRenderer.css';
import { StudyAudioPlayer } from './StudyAudioPlayer';

interface CardMediaRendererProps {
    imageUrl?: string | null;
    audioUrl?: string | null;
    onImageClick?: (url: string) => void;
}

export const CardMediaRenderer: React.FC<CardMediaRendererProps> = ({
    imageUrl,
    audioUrl,
    onImageClick
}) => {
    // ✅ NOVO: Ignorar imagens antigas (localhost)
    const isCloudinaryImage = imageUrl && imageUrl.includes('cloudinary.com');
    const isCloudinaryAudio = audioUrl && audioUrl.includes('cloudinary.com');

    // Se não tem mídia do Cloudinary, não renderiza
    if (!isCloudinaryImage && !isCloudinaryAudio) {
        return null;
    }

    return (
        <div className="cdmngr-container">
            {/* IMAGEM - só do Cloudinary */}
            {isCloudinaryImage && (
                <div className="cdmngr-image-wrapper">
                    <img
                        src={imageUrl}
                        alt="Card"
                        className="cdmngr-image"
                        onClick={(e) => {
                            e.stopPropagation();
                            onImageClick?.(imageUrl);
                        }}
                        loading="lazy"
                    />
                </div>
            )}

            {/* ÁUDIO - só do Cloudinary */}
            {isCloudinaryAudio && (
                <div
                    className="cdmngr-audio-wrapper"
                    onClick={(e) => e.stopPropagation()}
                >
                    <StudyAudioPlayer audioUrl={audioUrl} />
                </div>
            )}
        </div>
    );
};